"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledConnectedIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledConnectedIcon = styled_components_1.default.div `
  background: ${config_1.colors.greenBright};
  border-radius: 50%;
  height: 8px;
  margin-right: 5px;
  width: 8px;
`;
